import { NormalizedDealerOrder } from "./useNormalizedDealerOrder";

type Totals = {
  freightTotal: number;
  subtotal: number;
  total: number;
};

export const useTotals = (normalizedData: NormalizedDealerOrder[]): Totals => {
  const totals = normalizedData.reduce(
    (acc, item) => {
      const freightTotal = acc.freightTotal + item.freight;
      const subtotal = acc.subtotal + item.lineTotal;
      const total = freightTotal + subtotal;
      return { freightTotal, subtotal, total };
    },
    {
      freightTotal: 0,
      subtotal: 0,
      total: 0,
    }
  );
  return totals;
};
